<div class="super-admin-padding">
  <div class="super-admin-page theme-background-color">
    <div class="top-line">
      <div>
        <div class="super-admin-header">Super admin</div>
        <h1>Orgs</h1>
      </div>
      <div class="range-selector">
        <div>
          <mat-form-field>
            <mat-label>Pick Date format</mat-label>
            <mat-select
              (selectionChange)="selectedDateFormat($event.value)"
              [(value)]="defaultOption"
            >
              <mat-option *ngFor="let option of chartOptions" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field *ngIf="customOption">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input
              [formGroup]="dateRange"
              [rangePicker]="picker"
            >
              <input
                matStartDate
                formControlName="start"
                placeholder="Start date"
              />
              <input
                matEndDate
                formControlName="end"
                (dateInput)="customEndDateInput()"
                placeholder="End date"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="chart-grid">
      <div>
        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/view-homepage'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'View Homepage'"
        ></app-generate-chart>

        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/accounts'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'Registered Accounts'"
        ></app-generate-chart>

        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/orgs'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'Orgs'"
        ></app-generate-chart>
      </div>

      <div>
        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/payment-count'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'Payment Count'"
        ></app-generate-chart>

        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/payment-count-unique'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'Payment Count Unique'"
        ></app-generate-chart>
      </div>

      <div>
        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/messages'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'Messages'"
        ></app-generate-chart>

        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/tasks'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'Tasks'"
        ></app-generate-chart>
      </div>

      <div>
        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/login-attempt'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'Log In Attempt'"
        ></app-generate-chart>

        <app-generate-chart
          [endPoint]="'/api/super-admin/stats/login-success'"
          [selectedType]="selectedType"
          [start]="start"
          [end]="end"
          [chartLabel]="'Log In Success'"
        ></app-generate-chart>
      </div>
    </div>
  </div>
</div>
